import { ApiService } from '../../services/api_service';
import { ContextService } from '../../services/context_service';
import { getDefaultHelpIcon } from '../../helpers/getDefaultHelpIcon';
import { IDs } from '../../helpers/IDs';
import { lazyInject } from '../../services/inversify';
import parse from 'html-react-parser';
import * as React from 'react';
import { RoutingIDs } from '../../helpers/RoutingIDs';
import style from './Partner.less';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import { WArchivImage } from '../../core/elements/WArchivImage';

interface PartnerTabsProps extends React.ClassAttributes<any> {
    data: any;
    onRoutingChange: (routing: any) => void;
    routing: any;
}

interface PartnerTabsState {
    tabIndex: number;
}

export class PartnerTabs extends React.Component<PartnerTabsProps, PartnerTabsState> {

    constructor(props: any) {
        super(props);
        this.state = {
            tabIndex: this.contextService.get('tabIdxPartnerTabs') || 0
        };
    }

    @lazyInject(ApiService) private apiService: ApiService;
    @lazyInject(ContextService) private contextService: ContextService;

    componentDidMount(): void {
        this.checkRouting();
    }

    componentDidUpdate(prevProps: any) {
        if (this.props.routing !== prevProps.routing) {
            this.checkRouting();
        }
    }

    checkRouting(): void {
        const routing: any = this.props.routing || {};
        const tabName: string = RoutingIDs.TABS_INFORMATIONEN_HILFE_PARTNER;
        if (routing.path && routing.path[tabName] !== undefined) {
            // if ((routing.path.terminateOn || null) === tabName) {
            //     this.props.onRoutingChange({});
            // }
            // this.setTabIndex(routing.path[tabName], routing);
            if (this.state.tabIndex === routing.path[tabName]) {
                if (routing.path.terminateOn === tabName) {
                    this.props.onRoutingChange({});
                }
            } else {
                this.setTabIndex(routing.path[tabName], routing);
            }
        }
    }

    setTabIndex(tabIndex: number, tabRouting: any, callback?: () => void) {
        if (this.state.tabIndex !== tabIndex) {
            const routing: any = JSON.parse(JSON.stringify(this.props.routing || {}));
            const tabName: string = RoutingIDs.TABS_INFORMATIONEN_HILFE_PARTNER;
            if (routing.path && routing.path[tabName] === undefined) {
                // init default tabIndex
                routing.path[tabName] = this.state.tabIndex;
                this.props.onRoutingChange(routing);
            }
            setTimeout(() => {
                this.setState({ tabIndex }, () => {
                    this.props.onRoutingChange(tabRouting);
                    this.contextService.set('tabIdxPartnerTabs', tabIndex);
                    if (typeof callback === 'function') {
                        callback();
                    }
                });
            }, 0);
        }
    }

    render(): JSX.Element {
        const tabPanelstyle: React.CSSProperties = { flexDirection: 'column', display: 'flex', minHeight: 0, overflowY: 'auto' };

        const tabRoutings: Array<any> = [
            { path: RoutingIDs.ROUTE_PARTNER_FINANZIERUNG },
            { path: RoutingIDs.ROUTE_PARTNER_ENTWICKLUNG },
            { path: RoutingIDs.ROUTE_PARTNER_WEITERFUEHREND }
        ];

        return (
            <Tabs
                className='tabs-informationen_hilfe'
                style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}
                selectedIndex={this.state.tabIndex}
                // onSelect={
                //     (tabIndex, lastIndex, event) => this.setState(
                //         { tabIndex },
                //         () => this.contextService.set('tabIdxPartnerTabs', this.state.tabIndex)
                //     )
                // }
                onSelect={(tabIndex, lastIndex, event) => this.setTabIndex(tabIndex, tabRoutings[tabIndex])}
            >
                <TabList style={{ display: 'none' }}>
                    <Tab>Finanzierung</Tab>
                    <Tab>Entwicklung</Tab>
                    <Tab>Kooperationspartner:innen</Tab>
                </TabList>
                <TabPanel style={tabPanelstyle}>
                    {/* {getDefaultHelpIcon('pagePartnerFinanzierungE-Tool', 'Hilfe zu Finanzierung E-Tool', this.props.data)} */}
                    {this.renderPartner('finanzierung')}
                </TabPanel>
                <TabPanel style={tabPanelstyle}>
                    {/* {getDefaultHelpIcon('pagePartnerEntwicklungE-Tool', 'Hilfe zu Entwicklung E-Tool', this.props.data)} */}
                    {this.renderPartner('entwicklung')}
                </TabPanel>
                <TabPanel style={tabPanelstyle}>
                    {/* {getDefaultHelpIcon('pagePartnerKooperationspartner', 'Hilfe zu weiterführenden Kooperationspartner:innen', this.props.data)} */}
                    {this.renderPartner('weiterfuehrend')}
                </TabPanel>
            </Tabs>
        );
    }

    renderPartner(typ: string): JSX.Element {
        const bereich_key: string = this.apiService.getBereichKey();
        const whitelist: any[] = [];
        const regulated: any = {};

        (this.props.data[IDs.ENT_PARTNER_ZUORDNUNG] || []).forEach((item: any) => {
            if ((item.bereich_key_orig || item.bereich_key) === bereich_key && item.partner) {
                whitelist.push(item.partner_orig);
            }
            regulated[item.partner_orig] = true;
        });
        const filtered: any[] = (this.props.data[IDs.ENT_PARTNER] || []).filter((item: any) =>
            item.typ === typ && (!regulated[item.tid] || whitelist.indexOf(item.tid) !== -1));

        return (
            <div style={{ flexDirection: 'row', display: 'flex', flex: 1 }}>
                <div className={style.kacheln}>
                    <div>
                        {filtered.map((p: any, idx: number) => {
                            const link = p.link || null;
                            return <a
                                key={`partner-${idx}`}
                                href={link || '#'}
                                target={link ? '_blank' : null}
                                style={{
                                    ...link ? {} : { cursor: 'unset' }
                                }}
                            >
                                <div>
                                    <WArchivImage modul={IDs.MOD_ETOOL_ADMIN} archivId={p.logo || null} />
                                    <div>{parse(p.text || '')}</div>
                                    <div>{parse(p.kontaktdaten || '')}</div>
                                    {/*<div><p>{p.kontaktdaten || ''}</p></div>*/}
                                </div>
                            </a>;
                        })}
                    </div>
                </div>
            </div>
        );
    }
}
